/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';



/* ++++++++++ --------------- ROW ITEM - EMOJI CONFIG : STYLES --------------- ++++++++++ */
export default {
    rowitem: {
        '& td': {
            borderBottom: replacePXinStringWithEM('1px solid rgb(245, 245, 245)'),
            padding: replacePXinStringWithEM('13px 34px'),
            textTransform: 'capitalize',
            '&:first-child': {
                borderLeft: replacePXinStringWithEM('1px solid rgb(236, 236, 236)')
            },
            '&:last-child': {
                borderRight: replacePXinStringWithEM('1px solid rgb(236, 236, 236)')
            },
            '& .lastupdated': {
                display: 'flex',
                alignItems: 'center',
                '& .emojiicon': {
                    marginRight: pxToEm(15)
                },
                '& .lastupdate': {
                    color: 'rgb(171, 178, 195)',
                    fontSize: pxToEm(14),
                    textOverflow: 'ellipsis',
                    display: 'block',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                }
            },
            '& .contentscroller': {
                '& .emojiicon' : {
                    margin: '0 2px'
                }
            }
        }
    }
};
